import React from 'react';
import { makeStyles } from '@material-ui/core';

export const styles = makeStyles(theme => ({
  	title: {
        fontFamily: 'proxima-nova',
        fontStyle: 'normal',
        fontWeight: 800,
        fontSize: 25,
        lineHeight: '100%',
        textAlign: 'left',
        letterSpacing: -1,
        textTransform: 'uppercase',
		color: '#000000',
		margin: '32px 0px',
        [theme.breakpoints.up('sm')]: {
			fontSize: 35,
			margin: '48px 0px'
        }
	}
}));

export const PageTitle = ({title}) => {
	const classes = styles();
  
	return (
    	<div className={classes.title}>{title}</div>
	);
}